export default __webpack_public_path__ + "images/b48ba13479d07a04661b7ea2b2311afe.png";